import LiveVirtualClassIcon from 'img/icons/offering_icons/live-virtual-class-icon.svg';
import { LandingTab } from 'components/Landing/types';
import {
  BodyRowType,
  HeaderIconConfig,
  IconLabel,
  IconType,
  OfferingTypeConfig,
} from '../utils/types';
import {
  formatProductRows,
  getSessionsCustomIconRowConfig,
} from '../BodyBuilder/utils';

export const livePremiumSessionCourseIconConfig: HeaderIconConfig = {
  backgroundColor: '#007A87',
  iconTitle: 'Delivery format: Live Virtual Class',
  src: LiveVirtualClassIcon,
};

const livePremiumSessionCourseConfig: OfferingTypeConfig = {
  actionButtons: ({
    displayProgress,
    entry,
    premiumSessionCourseOfferingSlug,
    routerStore,
    t,
  }) => {
    const session = !entry
      ? premiumSessionCourseOfferingSlug
      : `${entry?.code}-${entry?.version}`;

    const routeName = 'premium:sessions:overview';
    const routeParams = { session, tab: LandingTab.PremiumSessions };

    return {
      actionButtonA: {
        buttonLabel: displayProgress ? t('Continue') : t('View'),
        href: routerStore.router.buildUrl(routeName, routeParams),
        icon: IconType.Arrow,
        onClick: () => routerStore.navigate(routeName, routeParams),
      },
    };
  },
  bodyRowsLayout: ({ hasSessionProgress }) => {
    if (hasSessionProgress) return [BodyRowType.Custom];
    return [BodyRowType.Icons, BodyRowType.Custom];
  },
  buildCustomRows: ({ offeringProducts, sessionProgress }) => {
    if (sessionProgress?.hasSessionProgress) {
      return getSessionsCustomIconRowConfig(sessionProgress.sessionsStatusList);
    }
    return formatProductRows(offeringProducts);
  },
  headerConfig: ({ t }) => ({
    iconB: livePremiumSessionCourseIconConfig,
    title: t('Live sessions'),
  }),
  iconRowsLayout: () => [[IconLabel.Level]],
};

export default livePremiumSessionCourseConfig;
